import React from 'react';
import styled from 'styled-components';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const SchedulingDemo = () => {
  return (
    <Container>
      <DotLottieReact
        src="https://lottie.host/56a434ac-2e30-4152-bd55-76d15dedf3e5/u4xpBAXODw.lottie"
        loop
        autoplay
      />
    </Container>
  );
};

export default SchedulingDemo;
